import './featured-boxes.scss';

import Swiper from 'swiper';
import { A11y, Navigation, Pagination, Keyboard } from 'swiper/modules';

class FeaturedBoxSlider {
    constructor ($element) {
        this.$featuredBox = $element;
        this.$featuredBoxSlider = this.$featuredBox.querySelector('[data-featured-box="slider"]');
        this.$slides = this.$featuredBoxSlider.querySelectorAll('.swiper-slide');
        this.$prevButton = null;
        this.$nextButton = null;
        this.$pagination = null;
        this.slider = null;

        this.prevSlideMessage = window.TRANSLATIONS.SLIDER.PREV_SLIDE_MESSAGE;
        this.nextSlideMessage = window.TRANSLATIONS.SLIDER.NEXT_SLIDE_MESSAGE;
        this.firstSlideMessage = window.TRANSLATIONS.SLIDER.FIRST_SLIDE_MESSAGE;
        this.lastSlideMessage = window.TRANSLATIONS.SLIDER.LAST_SLIDE_MESSAGE;
        this.slideLabel = window.TRANSLATIONS.SLIDER.SLIDE_LABEL;
        this.slideLabelFrom = window.TRANSLATIONS.SLIDER.SLIDE_LABEL_FROM;

        this.initialize();
    }

    initialize () {
        if (this.$slides.length > 1 && this.$slides.length < 4) {
            this.checkSize();
            this.setEvents();
        }

        if (this.$slides.length > 1 && this.$slides.length > 3) {
            this.initSlider();
        }
    }

    checkSize () {
        if (window.mediaMatchHandler[1024].matches) {
            this.destroySlider();
        } else {
            if (this.slider === null) {
                this.initSlider();
            }
        }
    }

    setEvents () {
        [1024, 768, 320].forEach((bp) => {
            window.mediaMatchHandler[bp].addEventListener('change', () => {
                this.checkSize();
            });
        });
    }

    initSlider () {
        this.$prevButton = this.$featuredBox.querySelector('[data-slider="prev"]');
        this.$nextButton = this.$featuredBox.querySelector('[data-slider="next"]');
        this.$pagination = this.$featuredBox.querySelector('[data-slider="pagination"]');

        this.slider = new Swiper(this.$featuredBoxSlider, {
            modules: [A11y, Navigation, Pagination, Keyboard],
            slidesPerView: 'auto',
            lazyPreloadPrevNext: true,
            autoHeight: false,
            speed: 500,
            a11y: {
                prevSlideMessage: this.prevSlideMessage,
                nextSlideMessage: this.nextSlideMessage,
                firstSlideMessage: this.firstSlideMessage,
                lastSlideMessage: this.lastSlideMessage,
                slideLabelMessage: `${this.slideLabel} {{index}} ${this.slideLabelFrom} {{slidesLength}}`,
            },
            pagination: {
                el: this.$pagination,
                type: 'bullets',
                clickable: false
            },
            navigation: {
                nextEl: this.$nextButton,
                prevEl: this.$prevButton
            },
            keyboard: true,
        });
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
        }
    }
}

export { FeaturedBoxSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$featuredBoxSlider = $context.querySelectorAll('[data-featured-box="root"]');

    if ($$featuredBoxSlider.length > 0) {
        $$featuredBoxSlider.forEach(($featuredBoxSlider) => {
            const featuredBoxSlider = new FeaturedBoxSlider($featuredBoxSlider); // eslint-disable-line
        });
    }
});
